import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faXTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";

const Socials: React.FC = () => {
    const socials = [
        { name: "Facebook", icon: faFacebook, color: "#1877F2", link: "https://www.facebook.com/democratie.blr/" },
        { name: "Instagram", icon: faInstagram, color: "#E4405F", link: "https://www.instagram.com/vivre_la_democratie_a_blr/" },
        { name: "X (Twitter)", icon: faXTwitter, color: "#000000", link: "https://x.com/JeanPhi56448637" },
        { name: "YouTube", icon: faYoutube, color: "#FF0000", link: "https://www.youtube.com/channel/UCzY-QlEXExtESHRTxgNII-w" },
    ];

    return (
        <Box>
            <Typography variant="subtitle2" align="center" fontWeight={700} color="text.secondary" gutterBottom sx={{ mb: 2, textTransform: "uppercase", letterSpacing: 1 }}>
                Retrouvez-nous sur les réseaux
            </Typography>

            <Grid container spacing={2}>
                {socials.map((social) => (
                    <Grid size={{ xs: 6 }} key={social.name}>
                        <Paper
                            component="a"
                            href={social.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            elevation={0}
                            sx={{
                                p: 1.5,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textDecoration: "none",
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 3,
                                bgcolor: "background.paper",
                                transition: "all 0.2s ease-in-out",
                                "&:hover": {
                                    borderColor: social.color,
                                    transform: "translateY(-2px)",
                                    boxShadow: `0 4px 12px -2px ${social.color}30`,
                                    "& .social-icon": {
                                        color: social.color,
                                        transform: "scale(1.1)",
                                    }
                                }
                            }}
                        >
                            <Box
                                className="social-icon"
                                sx={{
                                    fontSize: "1.5rem",
                                    color: "text.secondary",
                                    mb: 1,
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <FontAwesomeIcon icon={social.icon} />
                            </Box>

                            <Typography variant="caption" fontWeight={700} color="text.primary">
                                {social.name}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Socials;